export default "__VITE_ASSET__DJKQ_m0Z__"